<p-table #reqlist
         [columns]="cols"
         [value]="requisitions"
         [filters]="filters"
         [lazy]="true"
         (onLazyLoad)="loadRequisitionsLazy($event)"
         [paginator]="true"
         [rows]="80"
         [totalRecords]="totalRecords"
         [loading]="loading">
  <ng-template pTemplate="caption">
    <div style="height: 30px; width: 100%">
      <span class="float-left">Billing Requisition List</span>
      <div class="float-right ml-4">
        <a (click)="reqlist.filter('', 'Accession', 'equals')" class="text-white" style="font-size: 24px" href="javascript:void(0)" title="Refresh"><i class="fa-refresh fa"></i> </a>
      </div>
      <div class="float-right ml-4">
        <a (click)="clear(reqlist)" class="text-white" style="font-size: 24px" href="javascript:void(0)" title="Clear sort and filters"><i class="fa-undo fa"></i> </a>
      </div>
      <div class="float-right ml-4">
        <input pInputText type="text" (keyup.enter)="applyGlobalFilter($event.target.value, reqlist)" placeholder="Search keyword" />
      </div>
      <div class="float-right text-white font-weight-bold">
        {{totalRecords | number}} rows
      </div>
    </div>
  </ng-template>
  <ng-template pTemplate="header">
    <tr>
      <th [style]="{'width':'2%'}">&nbsp;</th>
      <th pSortableColumn="BillingStatus" [style]="{'width':'7%'}">
        <div>
          Bill Status
          <p-sortIcon field="BillingStatus" />
        </div>
      </th>
      <th pSortableColumn="Accession" [style]="{'width':'8%'}">
        <div>
          SID
          <p-sortIcon field="Accession" />
        </div>
      </th>
      <th [style]="{'width':'12%'}" pSortableColumn="PatientName">
        <div>
          Patient Name
          <p-sortIcon field="PatientName" />
        </div>
      </th>
      <th [style]="{'width':'13%'}" pSortableColumn="ClientName">
        <div>
          Client
          <p-sortIcon field="ClientName" />
        </div>
      </th>
      <th [style]="{'width':'7%'}" pSortableColumn="Birthdate">
        <div>
          Birth Date
          <p-sortIcon field="Birthdate" />
        </div>
      </th>
      <th [style]="{'width':'8%'}" pSortableColumn="LabPanelName">
        <div>
          Test
          <p-sortIcon field="LabPanelName" />
        </div>
      </th>
      <th [style]="{'width':'7%'}" pSortableColumn="DateOfService">
        <div>
          DOS
          <p-sortIcon field="DateOfService" />
        </div>
      </th>
      <th [style]="{'width':'7%'}" pSortableColumn="DateCompleted">
        <div>
          Resulted
          <p-sortIcon field="DateCompleted" />
        </div>
      </th>
      <th [style]="{'width':'15%'}" pSortableColumn="InsuranceList">
        <div>
          Insurance
          <p-sortIcon field="InsuranceList" />
        </div>
      </th>
      <th [style]="{'width':'7%'}" pSortableColumn="LabStatus">
        <div>
          Lab Status
          <p-sortIcon field="LabStatus" />
        </div>
      </th>
      <th pSortableColumn="BillingSubStatus" [style]="{'width':'7%'}">
        <div>
          Sub Status
          <p-sortIcon field="BillingSubStatus" />
        </div>
      </th>
    </tr>
    <tr>
      <th>&nbsp;</th>
      <th>
        <div class="flex">
          <p-columnFilter field="BillingStatus"
                          matchMode="in"
                          display="menu"
                          (click)="$event.stopPropagation()"
                          [showMatchModes]="false"
                          [showOperator]="false"
                          [showAddButton]="false">
            <ng-template pTemplate="filter" let-label let-filter="filterCallback">
              <p-multiSelect [(ngModel)]="billingStatuses"
                             optionLabel="label"
                             optionValue="label"
                             [options]="billingStatusList"
                             (onChange)="multiSelectFilter(filter, $event.value)"
                             placeholder="All Bill Statuses">
              </p-multiSelect>
            </ng-template>
          </p-columnFilter>
        </div>
      </th>
      <th>
        <p-columnFilter type="text"
                        field="Accession"
                        display="menu"
                        [showOperator]="false"
                        [showAddButton]="false" />
      </th>
      <th>
        <p-columnFilter type="text"
                        field="PatientName"
                        display="menu"
                        (click)="$event.stopPropagation()"
                        [showOperator]="false"
                        [showAddButton]="false" />
      </th>
      <th>
        <p-columnFilter type="text"
                        field="ClientName"
                        display="menu"
                        (click)="$event.stopPropagation()"
                        [showOperator]="false"
                        [showAddButton]="false" />
      </th>
      <th>
        <p-columnFilter type="date"
                        field="Birthdate"
                        display="menu"
                        (click)="$event.stopPropagation()"
                        [showOperator]="false" />
      </th>
      <th>
        <p-columnFilter type="text"
                        field="LabPanelName"
                        display="menu"
                        (click)="$event.stopPropagation()"
                        [showOperator]="false"
                        [showAddButton]="false" />
      </th>
      <th>
        <p-columnFilter type="date"
                        field="DateOfService"
                        display="menu"
                        (click)="$event.stopPropagation()"
                        [showOperator]="false" />
      </th>
      <th>
        <p-columnFilter type="date"
                        field="DateCompleted"
                        display="menu"
                        (click)="$event.stopPropagation()"
                        [showOperator]="false" />
      </th>
      <th>
        <p-columnFilter type="text"
                        field="InsuranceList"
                        display="menu"
                        (click)="$event.stopPropagation()"
                        [showOperator]="false"
                        [showAddButton]="false" />
      </th>
      <th>
        <p-columnFilter field="LabStatus"
                        matchMode="equals"
                        display="menu"
                        (click)="$event.stopPropagation()"
                        [showMatchModes]="false"
                        [showOperator]="false"
                        [showAddButton]="false">
          <ng-template pTemplate="filter" let-label let-filter="filterCallback">
            <p-select [(ngModel)]="labStatuses"
                      optionLabel="label"
                      [options]="labStatusList"
                      (onChange)="dropdownFilter(filter, $event.value.label)"
                      placeholder="All Lab Statuses">
            </p-select>
          </ng-template>
        </p-columnFilter>
      </th>
      <th>
        <div class="flex">
          <p-columnFilter field="BillingSubStatus"
                          matchMode="in"
                          display="menu"
                          (click)="$event.stopPropagation()"
                          [showMatchModes]="false"
                          [showOperator]="false"
                          [showAddButton]="false">
            <ng-template pTemplate="filter" let-label let-filter="filterCallback">
              <p-multiSelect [(ngModel)]="billingSubStatuses"
                             optionLabel="label"
                             optionValue="label"
                             [options]="billingSubStatusList"
                             (onChange)="multiSelectFilter(filter, $event.value)"
                             placeholder="All Sub Statuses">
              </p-multiSelect>
            </ng-template>
          </p-columnFilter>
        </div>
      </th>
    </tr>
  </ng-template>

  <ng-template pTemplate="body" let-rowData let-columns="columns">
    <tr>
      <td *ngFor="let col of columns" [ngSwitch]="col.field">
        <span *ngSwitchDefault>{{rowData[col.field]}}</span>
        <span *ngSwitchCase="'Eye'"><a style="cursor:pointer" (click)="rowData['showDetail'] = !rowData['showDetail'];"><i class="fa fa-eye"></i></a></span>
        <span *ngSwitchCase="'BirthDate'">{{rowData[col.field] | date:'MM/dd/yyyy'}}</span>
        <span *ngSwitchCase="'DateOfService'">{{rowData[col.field] | date:'MM/dd/yyyy'}}</span>
        <span *ngSwitchCase="'DateCompleted'">{{rowData[col.field] | date:'MM/dd/yyyy'}}</span>
      </td>
    </tr>
    <tr *ngIf="rowData['showDetail'] == true">
      <td colspan="12" style="background-color: lightgray; padding: 15px">
        <billing-detail requisitionId="{{rowData['Id']}}" (updatedBillingStatus)="updateBillingStatus($event)"></billing-detail>
      </td>
    </tr>
  </ng-template>
</p-table>
